<div class="message-popup-container">
    <div class="text-center" *ngIf="type === MessageType.Success">
        <img src="assets/icons/message-popup/success_icon.png" alt="success"/>
        <p class="text-title msg-success" *ngIf="title">{{ title }}</p>
    </div>
    <div class="text-center" *ngIf="type === MessageType.Error">
        <img src="assets/icons/message-popup/error_icon.png" alt="error"/>
        <p class="text-title msg-error" *ngIf="title">{{ title }}</p>
    </div>
    <div class="text-center" *ngIf="type === MessageType.Info">
        <img src="assets/icons/message-popup/info.png" alt="error"/>
        <p class="text-title msg-error" *ngIf="title">{{ title }}</p>
    </div>
    <div class="text-center">
        <p class="text-message" *ngIf="message">{{ message }}</p>
    </div>
    <div class="btn-card" *ngIf="buttons === Buttons.Okay">
        <button class="btn-blue" (click)="click(Button.Okay)">Okay</button>
    </div>
    <div class="btn-card" *ngIf="buttons === Buttons.YesCancel">
        <button class="btn-white" (click)="click(Button.Cancel)">Cancel</button>
        <button class="btn-blue" (click)="click(Button.Yes)">Yes</button>
    </div>
    <div class="btn-card" *ngIf="buttons === Buttons.OkayCancel ">
        <button class="btn-white" (click)="click(Button.Cancel)">Cancel</button>
        <button class="btn-blue" (click)="click(Button.Okay)">Okay</button>
    </div>
</div>